const RECOVERY_TYPE = 'recovery';

const readTokenHash = (search: string, type: string): string | null => {
  const params = new URLSearchParams(search);

  const tokenHash = params.get('token_hash');

  if (!tokenHash || params.get('type') !== type) {
    return null;
  }

  return tokenHash;
};

const readRecoveryTokenHash = (search: string): string | null => readTokenHash(search, RECOVERY_TYPE);

export {
  readRecoveryTokenHash,
};
